(() => {
  const activeObservers = new WeakMap();

  const setButtonLoading = (button, isLoading) => {
    button.classList.toggle('loading', isLoading);
    button.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
  };

  const syncButtons = (form) => {
    const productForm = form.closest('product-form');
    // The variant input named "id" can shadow form.id, so read the form attribute directly.
    const formId = form.getAttribute('id');
    if (!productForm || !formId) return;

    const mainButton = productForm.querySelector('.product-form__submit');
    const stickyButton = document.querySelector(`.product__mobile-sticky-submit[form="${formId}"]`);
    if (!mainButton || !stickyButton) return;

    activeObservers.get(mainButton)?.disconnect();

    const stickyWasDisabled = stickyButton.disabled;
    const stickyAriaDisabled = stickyButton.getAttribute('aria-disabled');

    const loadingObserver = new MutationObserver(() => {
      if (mainButton.classList.contains('loading')) return;

      loadingObserver.disconnect();
      const submissionFailed = mainButton.getAttribute('aria-disabled') === 'true';

      [mainButton, stickyButton].forEach((button) => setButtonLoading(button, false));
      mainButton.disabled = submissionFailed;
      stickyButton.disabled = submissionFailed || stickyWasDisabled;

      if (submissionFailed) {
        stickyButton.setAttribute('aria-disabled', true);
      } else if (stickyAriaDisabled === null) {
        stickyButton.removeAttribute('aria-disabled');
      } else {
        stickyButton.setAttribute('aria-disabled', stickyAriaDisabled);
      }

      activeObservers.delete(mainButton);
    });

    loadingObserver.observe(mainButton, {
      attributes: true,
      attributeFilter: ['class'],
    });
    activeObservers.set(mainButton, loadingObserver);

    [mainButton, stickyButton].forEach((button) => setButtonLoading(button, true));

    window.setTimeout(() => {
      if (!mainButton.classList.contains('loading')) return;

      [mainButton, stickyButton].forEach((button) => {
        button.disabled = true;
        button.setAttribute('aria-disabled', true);
      });
    }, 0);
  };

  document.addEventListener('click', (event) => {
    const submitButton = event.target.closest('.product-form__submit, .product__mobile-sticky-submit');
    const form = submitButton?.form;
    if (!form || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

    syncButtons(form);
  }, true);
})();
